import { render, staticRenderFns } from "./zatca-invoices.vue?vue&type=template&id=ec0e35f4&scoped=true"
import script from "./zatca-invoices.vue?vue&type=script&lang=js"
export * from "./zatca-invoices.vue?vue&type=script&lang=js"
import style0 from "./zatca-invoices.vue?vue&type=style&index=0&id=ec0e35f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0e35f4",
  null
  
)

export default component.exports